module.exports = __webpack_public_path__ + "media/news/berlin-news-02-31206c37.webp";